// extracted by mini-css-extract-plugin
module.exports = {"Table":"CMSRoutes_Table__33coo"};